import imagesStyle from "assets/jss/material-kit-react/imagesStyles.jsx";

const pictureHeroStyle = {
  ...imagesStyle,
  container: {
    margin: "90px 0px 30px 0px",
    borderRadius: "0px",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      margin: "90px 30px 30px 30px",
      borderRadius: "6px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  heroContainer: {
    backgroundColor: "#e5e5e5",
    borderRadius: "6px",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "6px",
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "6px"
    },
    "@media (min-width: 992px)": {
      borderRadius: "6px",
    },
    "@media (min-width: 1200px)": {
    }
  },
  imgContainer: {
    backgroundColor: "white",
    padding: "0px 0px 0px 0px",
    borderRadius: "0px",
    marginRight: "0px",
    marginLeft: "0px",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
    borderRadius: "6px 6px 0px 0px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 992px)": {
      marginTop: "0px",
      borderRadius: "6px",
    },
    "@media (min-width: 1200px)": {
    }
  },
  img: {
    minHeight: "300px",
    height: "50%",
    width: "100%",
    borderRadius: "0px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      height: "100%",
      borderRadius: "6px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  heroCard: {
    paddingTop: "0px"
  },
  title: {
    fontSize: "2.25rem",
    fontWeight: "700",
    textDecoration: "none",
    textAlign: "left",
    marginTop: "30px"
  },
  subtitle: {
    lineHeight: "1.5em",
    textAlign: "left",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
    },
    "@media (min-width: 992px)": {
    textAlign: "justify",
    },
    "@media (min-width: 1200px)": {
    }
  },
  text: {
    textAlign: "left",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
    textAlign: "justify",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    }
  },
  logoContainer: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "start"
  },
  logo: {
    height: "auto",
    width: "66%",
    margin: "-5% auto 5% auto",
    "@media (min-width: 576px)": {
      width: "50%",
    },
    "@media (min-width: 768px)": {
    },
    "@media (min-width: 960px)": {
      width: "90%",
      marginTop: "-10%",
      marginLeft: "-10%"
    },
    "@media (min-width: 992px)": {

    },
    "@media (min-width: 1200px)": {
    }
  },
  backgroundImageTop: {
    backgroundPosition: "50% 20%"
  },
  backgroundImageBottom: {
    backgroundPosition: "50% 80%"
  },
  waitlistBar: {
    width: "100%",
    textAlign: "right",
    color: "#A51CBE",
    "@media (min-width: 600px)": {
      textAlign: "center"
    },
  }
};

export default pictureHeroStyle;
